// extracted by mini-css-extract-plugin
export var avatar = "_is-3";
export var avatarContainer = "_is-2";
export var avatarSpacer = "_is-5";
export var avatarSpacerContainer = "_is-4";
export var avatarStackContainer = "_is-1";
export var bubble = "_is-0";
export var remainderBubble = "_is-6";